import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export interface IParamasGetInquiry {
  startDate?: string
  endDate?: string
}
export const GetInquiryAveragesAnalyticsService = async (params: IParamasGetInquiry) => {
  const response: any = await getByQuery<any>(`${services.analytics}/inquiry-averages-analytics`, params);
  return response?.data;
};